import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import bgImage from "../assets/cover.jpg";

export default function Menu() {
  const navigate = useNavigate();

  const menus = [
    {
      title: "Absensi Clock In",
      desc: "Kelola presensi masuk karyawan menggunakan kartu RFID",
      color: "text-blue-600",
      stripColor: "bg-green-500",
      route: "/absenclockin",
      icon: "🕗",
    },
    {
      title: "Absensi Clock Out",
      desc: "Kelola presensi keluar karyawan menggunakan kartu RFID",
      color: "text-blue-600",
      stripColor: "bg-red-500",
      route: "/absenclockout",
      icon: "🕔",
    },
    {
      title: "Power Control",
      desc: "Kontrol daya perangkat dengan sistem RFID",
      color: "text-green-600",
      stripColor: "bg-yellow-500",
      route: "/power",
      icon: "⚡",
    },
    {
      title: "Tracking People",
      desc: "Pantau pergerakan orang di area kerja dengan RFID",
      color: "text-purple-600",
      stripColor: "bg-purple-500",
      route: "/tracking",
      icon: "👣",
    },
  ];

  return (
    <div
      className="relative flex flex-col items-center justify-center min-h-screen"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      {/* Overlay gelap */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Logo */}
      <img
        src={logo}
        alt="SSD Logo"
        className="h-12 absolute top-4 left-6 z-20"
        onClick={() => navigate("/")}
      />

      {/* Content */}
      <div className="relative z-10 text-center text-white p-6 w-full max-w-5xl">
        <h1 className="text-4xl font-bold mb-10">RFID Smart System</h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {menus.map((menu, i) => (
            <div
            key={i}
            onClick={() => navigate(menu.route)}
            className="cursor-pointer bg-white rounded-2xl shadow-xl 
                        transform hover:scale-105 transition-all duration-300 
                        flex flex-col items-center relative overflow-hidden"
            >
            <div className={`absolute left-0 top-0 h-full w-2 ${menu.stripColor}`}></div>
                <div className="p-6 flex flex-col items-center">
                    <div className={`text-5xl mb-4 ${menu.color}`}>{menu.icon}</div>
                    <h2 className={`text-xl font-bold mb-2 ${menu.color}`}>
                    {menu.title}
                    </h2>
                    <p className="text-gray-600 text-sm">{menu.desc}</p>
                </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
